<template>
   
    <sweet-modal :id='configs.id' :title="title" v-on:close="closeHandler"
     :blocking="configs.blockBlur" overlay-theme="light" modal-theme="light" :ref="uuid">
        <div class="slot-content">
            <!-- <slot></slot> -->
            <ul class="nav nav-tabs">
                <li v-for="(tab, index) in tabs" :class="{'active': tab.name == start}"> <!--:class="{'active': index == 0}"-->
                    <a :href="'#'+tab.name" :id="'tab'+tab.name" @click="manualTab(tab.name)">{{tab.text}}</a>
                </li>
            
            </ul>
            <div class="tab-content">
			    <div v-for="(tab, index) in tabs" class="tab-pane" :class="{'active': tab.name == start}" :id="tab.name"> <!--:class="{'active': index == 0}"-->
                    <div style="padding: 10px;">
                        <slot :name="tab.name">
                            <div>Hai dimenticato di definire il tag con slot = {{tab.name}}</div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-footer" v-if="configs.showConfirmButton || configs.showCancelButton">
            <button v-if="configs.showCancelButton" class="btn btn-danger" @click.prevent="cancel">{{configs.cancelText}}</button>
            <button v-if="configs.showConfirmButton" class="btn btn-primary-default" @click.prevent="confirm">{{configs.confirmText}}</button>
        </div>
    </sweet-modal>

</template>
<script>

import { SweetModal } from "sweet-modal-vue";
import { toggleVisibility } from './toggleVisibilityMixin.js';

export default {
    props: {
        options: Object,
        tabs: {
            type: Array,
            default: function(){
                return [{
                    name: "1",
                    text: "First",
                    onLeave: function(){
                    },
                    onEnter: function(){
                    }
                }, {
                    name: "2",
                    text: "First",
                    onLeave: function(){
                    },
                    onEnter: function(){
                    }
                }]
            }
        },
        title: String,
        start:{
            type: String,
            default: ""
        },
        closeModal: {
            type: Function,
            default() {
                return null;
            }
        }
    },
    components: {
        SweetModal
    },
    mixins: [toggleVisibility],
    mounted: function(){
        if(this.options){
            this.overrideOptions();
        }
        if(this.tabs && this.tabs.length > 0){
            this.active = this.start //this.tabs[0].name;
        }
        var vm = this;
        this.$nextTick(function(){
            this.$emit("API", { open: this.$refs[this.uuid].open, close: this.$refs[this.uuid].close })
        });
    },
    data: function() {
        var vm = this;
        return {
            configs: {
                //title: '',
                subtitle: '',
                blockBlur: false,
                //setting default options
                showConfirmButton: true,
                showCancelButton: false,
                confirmText: 'Confirm',
                cancelText: 'Cancel',
                onConfirm: function(){
                    console.log("OK");
                },
                onCancel: function(){
                    console.log("DELETE");
                },
                closeAfterConfirm: true,
                closeAfterCancel: true,
                id:''
            },
            active: null
        }
    },
    methods: {
        overrideOptions: function(){
            for(var prop in this.options){
                this.configs[prop] = this.options[prop]
            }
        },
        cancel: function(e){
            if(this.configs.onCancel) this.configs.onCancel();
            if(this.configs.closeAfterCancel) this.close();
        },
        confirm: function(e){
            if(this.configs.onConfirm) this.configs.onConfirm();
            if(this.configs.closeAfterConfirm) this.close();
        },
        manualTab: function(w){
            var index = -1;
            this.tabs.some(function(t, i){
                if(t.name == this.active){
                    index = i;
                    return true;
                }
                return false;
            }, this);
            if(index != -1 && this.tabs[index].onLeave){
                this.tabs[index].onLeave();
            }
            
            $('#tab'+w).tab('show')
            this.active = w;

            index = -1;
            this.tabs.some(function(t, i){
                if(t.name == this.active){
                    index = i;
                    return true;
                }
                return false;
            }, this);
            if(index != -1 && this.tabs[index].onEnter){
                this.tabs[index].onEnter();
            }
        },
        closeHandler: function(){
            this.closeModal();
        }
    }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/dynamic/modalWrapper/TabModal.vue?a35b93a8